function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12ZM7.242 8.272a.343.343 0 0 0 0 .485L10.485 12l-3.243 3.243a.343.343 0 0 0 0 .485l1.03 1.03a.343.343 0 0 0 .486 0L12 13.515l3.243 3.243a.343.343 0 0 0 .485 0l1.03-1.03a.343.343 0 0 0 0-.486L13.515 12l3.243-3.242a.343.343 0 0 0 0-.485l-1.03-1.03a.343.343 0 0 0-.485 0L12 10.484 8.758 7.242a.343.343 0 0 0-.485 0l-1.03 1.03Z",
    fill: "#BE283A"
  }));
};
var componentName = 'ProgressErrorIcon';
export var ProgressErrorIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    style: {
      fontSize: '24px'
    },
    ref: ref
  }, props));
});
ProgressErrorIcon.displayName = componentName;